import { render, staticRenderFns } from "./InvoiceStatusPills.vue?vue&type=template&id=6438205b"
import script from "./InvoiceStatusPills.vue?vue&type=script&lang=js"
export * from "./InvoiceStatusPills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports